import { render, staticRenderFns } from "./Rating.vue?vue&type=template&id=e87f7360&scoped=true"
import script from "./Rating.vue?vue&type=script&lang=js"
export * from "./Rating.vue?vue&type=script&lang=js"
import style0 from "./Rating.vue?vue&type=style&index=0&id=e87f7360&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e87f7360",
  null
  
)

export default component.exports